import React from 'react';
import Alitalk from '@alife/alpha-alitalk';
import $ from '@alife/alpha-jquery/jquery';

export default class CallUsBtn extends React.PureComponent {
  componentDidMount() {
    const videoCallEl = $('.J-action-video');
    videoCallEl.attr('data-sceneType', 'detail');
    videoCallEl.attr('data-source', 'detail');

    Alitalk.renderList(videoCallEl, {
      renderCallback() {
        videoCallEl
          .find('.alitalk-unit')
          .attr('title', 'Call US')
          .html(
            '<img src="//img.alicdn.com/tfs/TB1rzXsIVT7gK0jSZFpXXaTkpXa-19-19.svg" alt="video-icon" style="margin-right:6px" />Call US',
          );
      },
    });
  }

  render() {
    const {
      i18n,
      ownMemberAlitalkEncryptId,
      contactEncryptId,
      productId,
      contactName,
      photoUrl,
    } = this.props;

    return (
      <button
        className="action-button-std action-video J-action-video"
        onClick={this.video}
        data-spm="pdpvideobtn"
        data-uid={ownMemberAlitalkEncryptId}
        data-pid={productId}
        data-contactid={contactEncryptId}
        data-biztype="1"
        data-contactname={contactName}
        data-contactimg={photoUrl}
        data-productid={productId}
        data-bizid={productId}
        data-action="callMeeting"
      >
        <img
          src="//img.alicdn.com/tfs/TB1rzXsIVT7gK0jSZFpXXaTkpXa-19-19.svg"
          alt="video-icon"
          style={{ marginRight: '6px', verticalAlign: 'bottom' }}
        />
        {i18n['rightAction.video'] || 'Call Us'}
      </button>
    );
  }
}
